document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("reviewsContainer");
  const reviewsContent = document.getElementById("reviewsContent");
  const reviewsGrid = document.getElementById("reviewsGrid");

  const isCarouselMode = container.dataset.carouselMode === "true";
  const carouselAutoplay = container.dataset.autoplay === "true";
  const autoplayDuration = parseInt(container.dataset.autoplayDuration) || 5;
  const slidesPerView = parseInt(container.dataset.slidesPerView) || 3;

  let carousel = null;

  const helpfulCounts = {};
  const helpfulClicked = {};

  if (isCarouselMode) {
    convertToCarousel();
  }

  initializeReviewInteractions();
  initializeFiltering();
  initializeModal();
  optimizeLayout();

  function convertToCarousel() {
    const carouselHTML = `
      <div class="reviews-carousel-container" id="reviewsCarousel">
        <button class="carousel-nav carousel-prev" id="carouselPrev" aria-label="Previous reviews">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <div class="reviews-carousel-track" id="carouselTrack" data-slides-per-view="${slidesPerView}">
          ${reviewsGrid.innerHTML}
        </div>
        <button class="carousel-nav carousel-next" id="carouselNext" aria-label="Next reviews">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
        <div class="carousel-pagination" id="carouselPagination" aria-hidden="true"></div>
      </div>
    `;

    reviewsContent.innerHTML =
      carouselHTML +
      reviewsContent.querySelector("#noResultsMessage").outerHTML;

    const slides = document.querySelectorAll("#carouselTrack .review-card");
    slides.forEach((slide) => slide.classList.add("carousel-slide"));

    initializeCarousel();
  }

  function initializeCarousel() {
    carousel = {
      track: document.getElementById("carouselTrack"),
      prevBtn: document.getElementById("carouselPrev"),
      nextBtn: document.getElementById("carouselNext"),
      pagination: document.getElementById("carouselPagination"),
      currentIndex: 0,
      autoplayInterval: null,

      init() {
        this.createPagination();
        this.bindEvents();
        this.updatePosition();
        if (carouselAutoplay) this.startAutoplay();
      },

      getCurrentSlidesPerView() {
        if (window.innerWidth <= 480) return 1;
        if (window.innerWidth <= 768) return Math.min(2, slidesPerView);
        return slidesPerView;
      },

      getVisibleSlides() {
        return Array.from(
          this.track.querySelectorAll(
            '.carousel-slide:not([style*="display: none"])'
          )
        );
      },

      getAllSlides() {
        return Array.from(this.track.querySelectorAll(".carousel-slide"));
      },

      createPagination() {
        if (!this.pagination) return;

        const visibleSlides = this.getVisibleSlides();
        const currentSlidesPerView = this.getCurrentSlidesPerView();
        const maxIndex = Math.max(
          0,
          visibleSlides.length - currentSlidesPerView
        );
        const totalPages = maxIndex + 1;

        this.pagination.innerHTML = "";

        if (totalPages > 1) {
          for (let i = 0; i < totalPages; i++) {
            const dot = document.createElement("div");
            dot.className = `carousel-dot ${i === 0 ? "active" : ""}`;
            dot.dataset.index = i;
            dot.setAttribute("aria-label", `Go to slide group ${i + 1}`);
            dot.addEventListener("click", () => this.goToVisible(i));
            this.pagination.appendChild(dot);
          }
        }
      },

      bindEvents() {
        this.prevBtn?.addEventListener("click", () => this.prev());
        this.nextBtn?.addEventListener("click", () => this.next());

        this.setupTouchGestures();
        this.setupHoverPause();
        this.setupKeyboardNav();
        this.setupResize();
      },

      updatePosition() {
        const currentSlidesPerView = this.getCurrentSlidesPerView();
        const slideWidth = 100 / currentSlidesPerView;

        const translateX = -(this.currentIndex * slideWidth);

        this.track.style.transform = `translateX(${translateX}%)`;
        this.updatePagination();
      },

      updatePagination() {
        const dots = this.pagination?.querySelectorAll(".carousel-dot");
        dots?.forEach((dot, index) => {
          dot.classList.toggle("active", index === this.currentIndex);
        });
      },

      next() {
        const visibleSlides = this.getVisibleSlides();
        const currentSlidesPerView = this.getCurrentSlidesPerView();
        const maxIndex = Math.max(
          0,
          visibleSlides.length - currentSlidesPerView
        );

        if (this.currentIndex < maxIndex) {
          this.currentIndex++;
          this.updatePosition();
          this.restartAutoplay();
        } else {
          this.pauseAutoplay();
        }
      },

      prev() {
        // if (this.currentIndex > 0) {
        //   this.currentIndex--;
        //   this.updatePosition();
        //   this.restartAutoplay();
        // } else {
        //   // Go to last visible slide group
        //   const visibleSlides = this.getVisibleSlides();
        //   const currentSlidesPerView = this.getCurrentSlidesPerView();
        //   const maxIndex = Math.max(
        //     0,
        //     visibleSlides.length - currentSlidesPerView
        //   );
        //   this.currentIndex = maxIndex;
        //   this.updatePosition();
        //   this.pauseAutoplay();
        // }
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.updatePosition();
          this.restartAutoplay();
        } else {
          // at first slide, don’t wrap—just pause autoplay
          this.pauseAutoplay();
        }
      },

      goToVisible(index) {
        const visibleSlides = this.getVisibleSlides();
        const currentSlidesPerView = this.getCurrentSlidesPerView();
        const maxIndex = Math.max(
          0,
          visibleSlides.length - currentSlidesPerView
        );

        this.currentIndex = Math.max(0, Math.min(index, maxIndex));
        this.updatePosition();
        this.restartAutoplay();
      },

      startAutoplay() {
        if (!carouselAutoplay) return;

        const visibleSlides = this.getVisibleSlides();
        const currentSlidesPerView = this.getCurrentSlidesPerView();
        const maxIndex = Math.max(
          0,
          visibleSlides.length - currentSlidesPerView
        );

        if (maxIndex > 0) {
          this.autoplayInterval = setInterval(() => {
            if (this.currentIndex < maxIndex) {
              this.next();
            } else {
              this.pauseAutoplay();
            }
          }, autoplayDuration * 1000);
        }
      },

      pauseAutoplay() {
        if (this.autoplayInterval) {
          clearInterval(this.autoplayInterval);
          this.autoplayInterval = null;
        }
      },

      resumeAutoplay() {
        if (carouselAutoplay && !this.autoplayInterval) this.startAutoplay();
      },

      restartAutoplay() {
        if (carouselAutoplay) {
          this.pauseAutoplay();
          setTimeout(() => this.resumeAutoplay(), 3000);
        }
      },

      setupTouchGestures() {
        let startX = 0;
        this.track.addEventListener(
          "touchstart",
          (e) => {
            startX = e.touches[0].clientX;
            this.pauseAutoplay();
          },
          { passive: true }
        );

        this.track.addEventListener(
          "touchend",
          (e) => {
            const endX = e.changedTouches[0].clientX;
            const diff = startX - endX;

            if (Math.abs(diff) > 50) {
              diff > 0 ? this.next() : this.prev();
            }
            this.resumeAutoplay();
          },
          { passive: true }
        );
      },

      setupHoverPause() {
        const carouselContainer = document.getElementById("reviewsCarousel");
        if (!carouselContainer) return;

        carouselContainer.addEventListener("mouseenter", () => {
          this.pauseAutoplay();
        });

        carouselContainer.addEventListener("mouseleave", () => {
          if (carouselAutoplay) this.resumeAutoplay();
        });

        this.prevBtn?.addEventListener("mouseenter", () =>
          this.pauseAutoplay()
        );
        this.nextBtn?.addEventListener("mouseenter", () =>
          this.pauseAutoplay()
        );
      },

      setupKeyboardNav() {
        document.addEventListener("keydown", (e) => {
          if (document.activeElement?.closest("#reviewsCarousel")) {
            if (e.key === "ArrowLeft") this.prev();
            if (e.key === "ArrowRight") this.next();
          }
        });
      },

      setupResize() {
        let resizeTimeout;
        window.addEventListener("resize", () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            // this.currentIndex = 0;
            this.createPagination();
            this.updatePosition();
            optimizeLayout();
          }, 250);
        });
      },
    };

    carousel.init();
  }

  function initializeReviewInteractions() {
    initializeHelpfulCounts();

    container.addEventListener("click", handleReviewCardClick);
    container.addEventListener("keydown", handleReviewCardKeydown);

    document.addEventListener("click", handleHelpfulButtonClick);

    truncateReviewText();
  }

  function initializeHelpfulCounts() {
    const reviewCards = document.querySelectorAll(".review-card");
    reviewCards.forEach((card) => {
      const reviewId = card.dataset.reviewId;
      const helpfulCount = card.querySelector(".helpful-count");
      if (reviewId && helpfulCount) {
        helpfulCounts[reviewId] = parseInt(helpfulCount.textContent) || 0;
      }
    });
  }

  function handleReviewCardClick(e) {
    const reviewCard = e.target.closest(".review-card");
    if (reviewCard && !e.target.closest(".helpful-button")) {
      e.preventDefault();
      openReviewModal(reviewCard);
    }
  }

  function handleReviewCardKeydown(e) {
    if (e.key === "Enter" || e.key === " ") {
      const reviewCard = e.target.closest(".review-card");
      if (reviewCard && !e.target.closest(".helpful-button")) {
        e.preventDefault();
        openReviewModal(reviewCard);
      }
    }
  }

  function handleHelpfulButtonClick(e) {
    const cardButton = e.target.closest(".helpful-button");
    const modalButton = e.target.closest(".modal-helpful-button");

    if (!cardButton && !modalButton) return;

    e.stopPropagation();

    let reviewId;
    let isModal = false;

    if (modalButton) {
      reviewId = modalButton.dataset.currentReviewId;
      isModal = true;
    } else if (cardButton) {
      const reviewCard = cardButton.closest(".review-card");
      reviewId = reviewCard?.dataset.reviewId;
    }

    if (!reviewId || helpfulClicked[reviewId]) return;

    if (helpfulCounts[reviewId] === undefined) {
      const countElement = isModal
        ? modalButton.querySelector(".helpful-count")
        : cardButton.querySelector(".helpful-count");

      helpfulCounts[reviewId] = countElement
        ? parseInt(countElement.textContent)
        : 0;
    }

    helpfulCounts[reviewId]++;
    helpfulClicked[reviewId] = true;

    updateHelpfulDisplay(reviewId);
  }

  function updateHelpfulDisplay(reviewId) {
    const cards = document.querySelectorAll(
      `.review-card[data-review-id="${reviewId}"]`
    );
    cards.forEach((card) => {
      const cardButton = card.querySelector(".helpful-button");
      if (!cardButton) return;

      const cardCount = cardButton.querySelector(".helpful-count");
      if (cardCount) {
        cardCount.textContent = helpfulCounts[reviewId];
      }

      cardButton.classList.add("active");
      cardButton.disabled = true;
      cardButton.setAttribute("aria-label", "Marked as helpful");
    });

    const modalButton = document.getElementById("modalHelpfulButton");
    if (modalButton && modalButton.dataset.currentReviewId === reviewId) {
      const modalCount = modalButton.querySelector(".helpful-count");
      if (modalCount) {
        modalCount.textContent = helpfulCounts[reviewId];
      }

      modalButton.classList.add("active");
      modalButton.disabled = true;
      modalButton.setAttribute("aria-label", "Marked as helpful");
    }
  }

  function truncateReviewText() {
    const maxLength = 180;
    document.querySelectorAll(".review-text").forEach((textElement) => {
      const fullText =
        textElement.dataset.fullText || textElement.textContent.trim();

      if (fullText.length > maxLength) {
        const truncatedText = fullText.substring(0, maxLength) + "...";
        textElement.textContent = truncatedText;
        textElement.dataset.fullText = fullText;
      } else {
        textElement.dataset.fullText = fullText;
      }
    });
  }

  function initializeFiltering() {
    const reviewCards = document.querySelectorAll(".review-card");
    const ratingFilter = document.getElementById("rating-filter");
    const sortOptions = document.getElementById("sort-options");
    const noResultsMessage = document.getElementById("noResultsMessage");
    const resetFilters = document.getElementById("resetFilters");

    function filterReviews() {
      if (isCarouselMode && carousel) {
        carousel.pauseAutoplay();
      }

      let visibleCount = 0;
      const ratingValue = ratingFilter?.value || "all";
      const containerElement = isCarouselMode
        ? document.getElementById("carouselTrack")
        : document.getElementById("reviewsGrid");

      reviewCards.forEach((card) => {
        const cardRating = card.dataset.rating;
        const ratingMatch = ratingValue === "all" || cardRating === ratingValue;

        if (ratingMatch) {
          card.style.display = "flex";
          visibleCount++;
        } else {
          card.style.display = "none";
        }
      });

      if (isCarouselMode && containerElement && visibleCount > 0) {
        const visibleCards = [];
        const hiddenCards = [];

        reviewCards.forEach((card) => {
          if (card.style.display !== "none") {
            visibleCards.push(card);
          } else {
            hiddenCards.push(card);
          }
        });

        containerElement.innerHTML = "";
        visibleCards.forEach((card) => containerElement.appendChild(card));
        hiddenCards.forEach((card) => containerElement.appendChild(card));
      }

      noResultsMessage.style.display = visibleCount === 0 ? "block" : "none";

      if (isCarouselMode && carousel && visibleCount > 0) {
        carousel.currentIndex = 0;
        carousel.track.style.transform = "translateX(0%)";
        carousel.createPagination();
        carousel.updatePagination();
      }

      setTimeout(() => {
        optimizeLayout();

        setTimeout(optimizeLayout, 200);
      }, 100);
    }

    function sortReviews() {
      if (isCarouselMode && carousel) {
        carousel.pauseAutoplay();
      }

      if (!sortOptions) return;

      const sortValue = sortOptions.value;
      const cardsArray = Array.from(reviewCards);
      const containerElement = isCarouselMode
        ? document.getElementById("carouselTrack")
        : document.getElementById("reviewsGrid");

      if (!containerElement) return;

      cardsArray.sort((a, b) => {
        if (sortValue === "recent") {
          return new Date(b.dataset.date) - new Date(a.dataset.date);
        } else if (sortValue === "highest") {
          return b.dataset.rating - a.dataset.rating;
        } else if (sortValue === "lowest") {
          return a.dataset.rating - b.dataset.rating;
        }
        return 0;
      });

      cardsArray.forEach((card) => containerElement.appendChild(card));

      if (ratingFilter?.value !== "all") {
        filterReviews();
      } else if (isCarouselMode && carousel) {
        carousel.currentIndex = 0;
        carousel.track.style.transform = "translateX(0%)";
        carousel.createPagination();
        carousel.updatePagination();
      }
    }

    ratingFilter?.addEventListener("focus", () => {
      if (isCarouselMode && carousel) {
        carousel.pauseAutoplay();
      }
    });

    sortOptions?.addEventListener("focus", () => {
      if (isCarouselMode && carousel) {
        carousel.pauseAutoplay();
      }
    });

    ratingFilter?.addEventListener("click", () => {
      if (isCarouselMode && carousel) {
        carousel.pauseAutoplay();
      }
    });

    sortOptions?.addEventListener("click", () => {
      if (isCarouselMode && carousel) {
        carousel.pauseAutoplay();
      }
    });

    ratingFilter?.addEventListener("change", filterReviews);
    sortOptions?.addEventListener("change", sortReviews);
    resetFilters?.addEventListener("click", () => {
      if (isCarouselMode && carousel) {
        carousel.pauseAutoplay();
      }
      if (ratingFilter) ratingFilter.value = "all";
      filterReviews();
    });
  }

  function initializeModal() {
    const section = document.getElementById("reviewsContainer");
    const modal = document.getElementById("reviewModal");
    const computedStyles = window.getComputedStyle(section);

    const cssVars = [
      "--reviews-primary-color",
      "--reviews-bg-color",
      "--reviews-card-bg",
      "--reviews-text-primary",
      "--reviews-text-secondary",
      "--reviews-text-muted",
      "--reviews-border-color",
      "--reviews-modal-button-color",
      "--reviews-dropdown-bg",
      "--reviews-dropdown-text",
      "--reviews-dropdown-option-bg",
      "--reviews-dropdown-option-text",
      "--reviews-shadow",
      "--reviews-radius",
      "--reviews-transition",
    ];

    cssVars.forEach((varName) => {
      const value = computedStyles.getPropertyValue(varName);
      modal.style.setProperty(varName, value);
    });

    const closeButton = modal.querySelector(".close-modal");
    let currentSlide = 0;
    let slideImages = [];

    window.openReviewModal = function (reviewCard) {
      const reviewData = JSON.parse(reviewCard.dataset.reviewData);
      const reviewId = reviewCard.dataset.reviewId;

      if (helpfulCounts[reviewId] !== undefined) {
        reviewData.helpfulCount = helpfulCounts[reviewId];
      } else {
        const currentCount = reviewCard.querySelector(".helpful-count");
        if (currentCount) {
          reviewData.helpfulCount =
            parseInt(currentCount.textContent) || reviewData.helpfulCount;
          helpfulCounts[reviewId] = reviewData.helpfulCount;
        }
      }

      const modalButton = document.getElementById("modalHelpfulButton");
      if (modalButton) {
        modalButton.dataset.currentReviewId = reviewId;
      }

      populateModal(reviewData, reviewId);
      showModal();
    };

    function populateModal(data, reviewId) {
      document.getElementById("modalReviewerName").textContent =
        data.reviewerName;
      document.getElementById("modalReviewText").textContent = data.reviewText;
      document.getElementById("modalReviewDate").textContent = data.reviewDate;
      document.getElementById("modalHelpfulCount").textContent =
        data.helpfulCount;

      const modalRatingStars = document.getElementById("modalRatingStars");
      modalRatingStars.innerHTML = `<img src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-${data.rating}.svg" alt="" class="stars-image large" width="120" height="24">`;
      document.getElementById(
        "modalRatingText"
      ).textContent = `${data.rating} out of 5 stars`;

      const verifiedTag = document.getElementById("modalVerifiedTag");
      verifiedTag.style.display = data.verifiedPurchase ? "flex" : "none";

      const productInfo = document.getElementById("productInfo");
      if (data.productTitle) {
        document.getElementById("modalItemType").textContent =
          data.productTitle;
        document.getElementById("modalProductButton").href = data.productUrl;
        productInfo.style.display = "block";
      } else {
        productInfo.style.display = "none";
      }

      const modalButton = document.getElementById("modalHelpfulButton");
      if (modalButton) {
        modalButton.dataset.currentReviewId = reviewId;

        modalButton.classList.remove("active");
        modalButton.disabled = false;
        modalButton.setAttribute("aria-label", "Mark review as helpful");

        if (helpfulClicked[reviewId]) {
          modalButton.classList.add("active");
          modalButton.disabled = true;
          modalButton.setAttribute("aria-label", "Marked as helpful");

          const modalCount = modalButton.querySelector(".helpful-count");
          if (modalCount) {
            modalCount.textContent = helpfulCounts[reviewId];
          }
        }
      }

      setupModalMedia(data);
    }

    function setupModalMedia(data) {
      const modalMediaContainer = document.getElementById(
        "modalMediaContainer"
      );
      const imageSlider = document.getElementById("imageSlider");

      modalMediaContainer.innerHTML = "";
      imageSlider.style.display = "none";
      slideImages = [];
      currentSlide = 0;

      const altText = data.productTitle
        ? `${data.productTitle} - Customer review`
        : "Customer review";

      // Collect ALL available images (including new ones)
      const images = [
        data.primaryImageUrl,
        data.secondaryImageUrl,
        data.tertiaryImageUrl,
        data.quaternaryImageUrl,
      ].filter((url) => url && url.trim() !== "");

      if (data.hasVideo) {
        setupVideoModal(data, altText);
        modalMediaContainer.style.display = "block";
      } else if (images.length >= 2) {
        // Multiple images: use slider
        slideImages = images;
        setupImageSlider(altText);
        imageSlider.style.display = "block";
        modalMediaContainer.style.display = "none"; // Hide direct container
      } else if (images.length === 1) {
        // Single image: show directly
        modalMediaContainer.innerHTML = `
          <img src="${images[0]}" 
               alt="${altText}" 
               class="modal-image"
               loading="lazy">
        `;
        modalMediaContainer.style.display = "block";
      } else {
        modalMediaContainer.style.display = "none";
      }
    }

    function setupVideoModal(data, altText) {
      const videoContainer = document.querySelector(
        `#videoDataContainer [data-review-id="${data.id}"]`
      );
      if (videoContainer) {
        const modalMediaContainer = document.getElementById(
          "modalMediaContainer"
        );
        const videoClone = videoContainer.cloneNode(true);
        const videoElement = videoClone.querySelector("video");

        if (videoElement) {
          videoElement.setAttribute("aria-label", altText);
          videoElement.setAttribute("title", altText);
        }

        modalMediaContainer.innerHTML = `
          <div class="video-container">
            ${videoClone.innerHTML}
            <span class="visually-hidden">${altText}</span>
          </div>
        `;

        if (videoElement && data.primaryImageUrl) {
          videoElement.poster = data.primaryImageUrl;
        }
      }
    }

    function setupImageSlider(altText) {
      const slidesContainer = document.getElementById("slidesContainer");
      const sliderPagination = document.getElementById("sliderPagination");

      slidesContainer.innerHTML = "";
      sliderPagination.innerHTML = "";

      slideImages.forEach((imgUrl, index) => {
        const slide = document.createElement("div");
        slide.className = `slide ${index === 0 ? "active-slide" : ""}`;
        slide.innerHTML = `
          <img src="${imgUrl}" 
               alt="${altText} (image ${index + 1})" 
               loading="lazy">`;
        slidesContainer.appendChild(slide);

        const dot = document.createElement("div");
        dot.className = `pagination-dot ${index === 0 ? "active" : ""}`;
        dot.addEventListener("click", () => goToSlide(index));
        sliderPagination.appendChild(dot);
      });

      // Re-bind event listeners
      document
        .getElementById("prevSlide")
        .addEventListener("click", previousSlide);
      document.getElementById("nextSlide").addEventListener("click", nextSlide);

      // Initialize first slide visibility
      if (slideImages.length > 0) {
        goToSlide(0);
      }
    }

    function goToSlide(index) {
      currentSlide = index;
      document.querySelectorAll(".slide").forEach((slide, i) => {
        slide.classList.toggle("active-slide", i === index);
      });
      document.querySelectorAll(".pagination-dot").forEach((dot, i) => {
        dot.classList.toggle("active", i === index);
      });
    }

    function nextSlide() {
      goToSlide((currentSlide + 1) % slideImages.length);
    }

    function previousSlide() {
      goToSlide((currentSlide - 1 + slideImages.length) % slideImages.length);
    }

    function showModal() {
      modal.style.display = "block";
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";

      setTimeout(() => {
        closeButton?.focus();
      }, 100);
    }

    function closeModal() {
      modal.style.display = "none";
      modal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";

      const videos = modal.querySelectorAll("video");
      videos.forEach((video) => {
        video.pause();
        video.currentTime = 0;
      });
    }

    closeButton?.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });

    document.addEventListener("keydown", (e) => {
      if (modal.style.display === "block") {
        if (e.key === "Escape") closeModal();
        else if (e.key === "ArrowLeft") previousSlide();
        else if (e.key === "ArrowRight") nextSlide();
      }
    });
  }

  function optimizeLayout() {
    const hasTrustpilot = container.dataset.hasTrustpilot === "true";
    const header = container.querySelector(".reviews-header");
    const content = container.querySelector(".reviews-content");
    const trustpilot = container.querySelector(".trustpilot-signature-wrapper");

    let totalHeight = 0;

    if (header) totalHeight += header.offsetHeight;

    if (content) {
      const visibleCards = content.querySelectorAll(
        '.review-card:not([style*="display: none"])'
      );
      if (visibleCards.length > 0) {
        const cardHeight = visibleCards[0].offsetHeight;
        totalHeight += cardHeight + 40;
      } else {
        totalHeight += 400;
      }

      if (isCarouselMode) {
        totalHeight += 35;
      }
    }

    if (hasTrustpilot && trustpilot) {
      totalHeight += trustpilot.offsetHeight;
    }

    totalHeight = Math.max(totalHeight, 400);

    container.style.height = totalHeight + "px";
  }

  const images = container.querySelectorAll("img");
  let loadedImages = 0;

  images.forEach((img) => {
    if (img.complete) {
      loadedImages++;
    } else {
      img.addEventListener("load", () => {
        loadedImages++;
        if (loadedImages === images.length) {
          optimizeLayout();
        }
      });
    }
  });

  if (loadedImages === images.length) {
    optimizeLayout();
  }
});
